var _rect, _mask, _path, _mask2, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobiledevendasIcone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4,
    fill: "#E0F4F4"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1395_19931",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1604 46C12.5195 46 12 45.4805 12 44.8396L12 17.3774C12 10.5415 17.5415 5 24.3774 5L25.0709 5C31.9068 5 37.4483 10.5415 37.4483 17.3774L37.4483 33.6226C37.4483 40.4585 31.9067 46 25.0709 46L13.1604 46Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1604 46C12.5195 46 12 45.4805 12 44.8396L12 17.3774C12 10.5415 17.5415 5 24.3774 5L25.0709 5C31.9068 5 37.4483 10.5415 37.4483 17.3774L37.4483 33.6226C37.4483 40.4585 31.9067 46 25.0709 46L13.1604 46Z",
    stroke: "url(#paint0_linear_1395_19931)",
    strokeWidth: 4.64151,
    mask: "url(#path-2-inside-1_1395_19931)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_1395_19931",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3057 20.7495C31.3057 24.1675 28.5349 26.9382 25.117 26.9382L19.3031 26.9382C18.6623 26.9382 18.1428 26.4187 18.1428 25.7779L18.1428 17.3314C18.1428 13.9135 20.9135 11.1427 24.3314 11.1427L25.117 11.1427C28.5349 11.1427 31.3057 13.9135 31.3057 17.3314L31.3057 20.7495Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3057 20.7495C31.3057 24.1675 28.5349 26.9382 25.117 26.9382L19.3031 26.9382C18.6623 26.9382 18.1428 26.4187 18.1428 25.7779L18.1428 17.3314C18.1428 13.9135 20.9135 11.1427 24.3314 11.1427L25.117 11.1427C28.5349 11.1427 31.3057 13.9135 31.3057 17.3314L31.3057 20.7495Z",
    stroke: "url(#paint1_linear_1395_19931)",
    strokeWidth: 4.64151,
    mask: "url(#path-3-inside-2_1395_19931)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1395_19931",
    x1: 12,
    y1: 25.5,
    x2: 37.4483,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68BAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253A4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1395_19931",
    x1: 24.7242,
    y1: 26.9382,
    x2: 24.7242,
    y2: 11.1427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68BAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253A4E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobiledevendasIcone);
export default __webpack_public_path__ + "static/media/mobiledevendas_icone.f703b54a3098a0dc8f7f3571078333bb.svg";
export { ForwardRef as ReactComponent };